<template>
  <div>
    <Head title="Day Logs" />
    <div class="flex items-center justify-between mb-10">
      <h1 class="text-3xl font-bold">Day Logs</h1>
      <Link v-show="false" class="btn-indigo" href="/daylogs/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Day Log</span>
      </Link>
    </div>

    <div id="daylinksCalendar" class="text-center">
      <div id="legend">
        Projected Delivery
        <div class="lholder"><span id="projecteddelivery"></span></div> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        DayLog Entered
        <div class="lholder"><span class="daylogentered"></span></div>
      </div>
      <DatePicker expanded :initial-page="{ month: this.moment().format('MM'), year: this.moment().format('YYYY') }" v-model="datePicked" :attributes="calData" mode="date" :rows="3" :step="1" :dayclick="this.dayClicked(datePicked)" />
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <div id="daylinksholder">
        <div id="daylinks"></div>
      </div>
      <div id="updatejobsite" ></div>
    </div>
  </div>
</template>
<style>
  .lholder { position:relative; display:inline-block; }
  #legend { position:absolute; 
    top:-35px;
  }
  #projecteddelivery {
    display:inline-block;
    height:3px;
    width:40px;
    background:#2563EB;
  }
 .daylogentered {
    height:30px;
    width:30px;
    background:#FFF; font-weight:bold; border-radius:3px; 
  }
  .daylogentered::before {
    width: 0;
      height: 0;
      border-bottom: 14px solid #ffd91e;
      border-right: 14px solid transparent;
      position:absolute;
      content:' ';
      left:0;
      bottom:0;
      cursor:pointer;
  }

  #daylinks { 
    background: #eae9e9;
  }
  .daylink { display:inline-block; padding:3px; margin:5px; height:40px; width:40px; box-sizing:border-box; border:2px solid #FFF;  position:relative; font-size:14px; }
  .daylink.false { pointer-events:none !important; border:2px solid #EAE9E9; user-select: none; }
  .daylink:hover { border:2px solid #ffd91e; background:#FFF; box-sizing:border-box; }
  .editdayloglinkoverlay { background:#FFF; font-weight:bold; border-radius:3px; }
  .editdayloglinkoverlay::before {
      width: 0;
      height: 0;
      border-bottom: 14px solid #ffd91e;
      border-right: 14px solid transparent;
      position:absolute;
      content:' ';
      left:0;
      bottom:0;
      cursor:pointer;
  }

  .projectedlinkoverlay { background:#FFF; font-weight:bold; border-radius:3px; }
  .projectedlinkoverlay::before {
      width: 0;
      height: 0;
      border-top: 14px solid #46ddff;
      border-left: 14px solid transparent;
      position:absolute;
      content:' ';
      top:0;
      right:0;
      cursor:pointer;
  }

  .daylog-month {
    width:350px;
    height:400px;
    position:relative;
    display:inline-block;
    text-align: center;
    margin:25px 45px;
  }
  .daylog-month h3 {
    background: #FFF;
    padding: 10px 0px;
  }
  #daylinksholder { position:relative; }
  #daylinksCalendar { margin:20px auto; max-width:450px; position:relative; }
  #daylinksCalendar > div {  }
  .vc-container .vc-highlight-bg-solid {
    border-radius:0;
  }

  .vc-container .vc-highlight-bg-solid { position: relative; background:#fffdf3; font-weight:bold; border:1px dotted #241e00; }
  .vc-container .vc-highlight-content-solid { color:#333; }
  .vc-container .vc-day { min-height:60px; }
  .vc-container .vc-day-content { font-size:18px; width:40px; height:40px; border-radius:0 !important; }
  .vc-container .vc-day-content:hover { background-color:#FFD91E77;  border:1px dotted #241e00;}
  .vc-container .vc-highlight {width:35px; height:35px; }
  .vc-container .vc-highlight-bg-solid::before {
      width: 0;
      height: 0;
      border-bottom: 14px solid #ffd91e;
      border-right: 14px solid transparent;
      position:absolute;
      content:' ';
      left:0;
      bottom:0;
      cursor:pointer;
  }
  .vc-monthly .is-not-in-month * {
    /* opacity:0.4; */
  }
@media only screen and (max-width:500px) {
  .daylog-month {
      margin:0;
      transform:scale(0.9);
  }
}
</style>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import SelectInput from '@/Shared/SelectInput'
import moment from 'moment'
import '@vuepic/vue-datepicker/dist/main.css'
import 'v-calendar/style.css';
import { setupCalendar, DatePicker, Calendar } from 'v-calendar';
import { ref } from 'vue';


export default {
  mounted() {
    //this.daylinkbuilder();
  },
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    SelectInput,
    Calendar,
    DatePicker,
  },
  layout: Layout,
  props: {
    filters: Object,
    daylogs: Object,
    jobsites: Object,
    auth: Object,
    orders: Object,
  },
  data() {
    return {
      datePicked: null,
      calData: ref([
        { // Day Logs
          highlight: true,
          dates: this.getDayLogDates(), //array of: new Date(2022, 10, 2),
        },
        { // Projected Deliveries
          bar: 'sky-blue',
          dates: this.getOrderProjections(), //array of new Date...
        },
      ]),
      form: {
        //search: this.filters.search,
        //trashed: this.filters.trashed,
            jobsite_id: null,
            superintendent: null,
            temp_low: null,
            temp_high: null,
            rain: false,
            snow: false,
            ice: false,
            wind: false,
            sun: false,
            other_weather: null,
            rentals_deliveries: null,
            hinderance_notes: null,
            additional_notes: null,
            progress: {},
            orderupdates: {},
            reportday: null,
      },
      moment: moment,
      filteredjobsites: this.authjobsites(),
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/daylogs', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    dayClicked(datePicked) {
      try {
        var dclicked = moment(datePicked).format('YYYYMMDD');
        var jobsiteselid = document.querySelector('#jobsiteselector').value;
        var hrefgo;
        if (this.auth.user.role == 'ADMIN' || this.auth.user.role == 'USER' || this.auth.user.role == 'SUPER') { hrefgo = "/daylogs/create/?d=" + dclicked + "&j=" + jobsiteselid; }
        if (dclicked != "Invalid date") {
          if (this.daylogs) { 
            var daylogarr = Object.entries(this.daylogs);
            daylogarr.forEach((daylogo) => {           
              var daylog = Object.entries(daylogo)[1][1];
              if (daylog.reportday == dclicked) {
                hrefgo = "daylogs/" + daylog.id + "/edit";
              }
            });
          }

          window.location = (typeof(hrefgo) == 'undefined')? '#' : hrefgo;
        }
      } catch(e) {

      }
    },
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    authjobsites() {
      var jsa = JSON.parse(this.auth.user.jobsiteaccess);
      var jobsitesyes = [];
      this.jobsites.data.forEach((js) => {
        if (jsa[js.id] == 1) {
          jobsitesyes.push(js);
        }
      });
      return jobsitesyes;
    },
    getDayLogDates() {
      var returndates = [];
      if (this.daylogs) { 
        var daylogarr = Object.entries(this.daylogs);
        daylogarr.forEach((daylogo) => {           
          var daylog = Object.entries(daylogo)[1][1];
          //daylog.reportday;
          //daylog.id
          var ny = parseInt(daylog.reportday.substring(0,4));
          var nm = parseInt(daylog.reportday.substring(4,6))-1;
          var nd = parseInt(daylog.reportday.substring(6,8));
          var ndate = new Date(ny, nm, nd);
          
          if (ndate != "Invalid Date") {
            returndates.push(ndate);
          }
        });
      }
      return returndates;
    },
    getOrderProjections() {
      var daypickprojection = [];
      if (this.orders) {
        var ordersarr = Object.entries(this.orders);

        ordersarr.forEach((ordero) => {
          var order = Object.entries(ordero)[1][1];
          if (order.products) {
            var prodtoprocess = JSON.parse(order.products);
            if (prodtoprocess.length > 0)
            prodtoprocess.forEach(product => {
              if (product.projected_delivery) {
                var pd = new Date(
                  parseInt(product.projected_delivery.split('-')[0]), 
                  parseInt(product.projected_delivery.split('-')[1])-1, 
                  parseInt(product.projected_delivery.split('-')[2])
                );
                daypickprojection.push(pd);
              }
            });
          }
        });
      }
      return daypickprojection;
    },
    daylinkbuilder() {
      var dlhtml = '<div class="daylog-month">';
      var i = 0;
      var daypickdata;
      var daypickhaslink = false;
      var month = '';
      var year = '';
      var projectstartday = "20221201";
      var daypickprojection;
      month = moment(projectstartday,'YYYYMMDD').format('MMMM');
      year = moment(projectstartday,'YYYYMMDD').format('YY');
      dlhtml += '<h3 class="text-lg font-bold">' + month + " '" + year + '</h3><br/>';
      var mdowstart = parseInt(moment(projectstartday,'YYYYMMDD').add(i,'days').day());
      if (mdowstart > 0) {
        while (mdowstart > 0) {
          dlhtml += '<a href="#" class="daylink false">&nbsp;</a>';
          mdowstart--;
        }
      }
      while (i <243) {
        if (month !== moment(projectstartday,'YYYYMMDD').add(i,'days').format('MMMM')) {
          month = moment(projectstartday,'YYYYMMDD').add(i,'days').format('MMMM');
          year = moment(projectstartday,'YYYYMMDD').add(i,'days').format('YY');
          dlhtml += "<a href='#' class='daylink false'>&nbsp;</a><a href='#' class='daylink false'>&nbsp;</a><a href='#' class='daylink false'>&nbsp;</a><a href='#' class='daylink false'>&nbsp;</a><a href='#' class='daylink false'>&nbsp;</a></div><div class='daylog-month'><h3 class='text-lg font-bold'>" + month + " '" + year + "</h3><br/>"; 
          var mdowstart2 = parseInt(moment(projectstartday,'YYYYMMDD').add(i,'days').day());
          if (mdowstart2 > 0) {
            while (mdowstart2 > 0) {
              dlhtml += '<a href="#" class="daylink false">&nbsp;</a>';
              mdowstart2--;
            }
          }
        }
        daypickprojection = '';
        if (this.orders.length > 0) {
          this.orders.forEach(order => {
            if (order.products) {
              daypickprojection = '';
              var prodtoprocess = JSON.parse(order.products);
              if (prodtoprocess.length > 0)
              prodtoprocess.forEach(product => {
                var deltest = product.projected_delivery ? product.projected_delivery.replace('-','').replace('-','') : '';
                if (deltest == moment(projectstartday, "YYYYMMDD").add(i,'days').format('YYYYMMDD')) {
                  daypickprojection = '<span class="projectedlinkoverlay"></span>';
                }
              });
            }
          });
        }
        
        var jobsiteselid = document.querySelector('#jobsiteselector').value;

        
        if (this.auth.user.role == 'ADMIN') { daypickdata = "daylogs/create/?d=" + moment(projectstartday, "YYYYMMDD").add(i,'days').format('YYYYMMDD') + "&j=" + jobsiteselid; }
        daypickhaslink = (((daypickdata + "").indexOf('edit') > -1) ? '<span class="editdayloglinkoverlay"></span>' : "");
        dlhtml += '<a href="/' + daypickdata + '" class="daylink' +  
          " day" + moment(projectstartday, "YYYYMMDD").add(i,'days').format('YYYYMMDD') +
          '">' + moment(projectstartday, "YYYYMMDD").add(i,'days').format('D') + daypickhaslink + "" + daypickprojection + '</a>';
        i++
      }
      dlhtml += '<a href="#" class="daylink false">&nbsp;</a><a href="#" class="daylink false">&nbsp;</a><a href="#" class="daylink false">&nbsp;</a><a href="#" class="daylink false">&nbsp;</a><a href="#" class="daylink false">&nbsp;</a></div>';
      document.querySelector('#daylinks').innerHTML = dlhtml;

      if (this.daylogs) { 
        var daylogarr = Object.entries(this.daylogs);
        daylogarr.forEach((daylogo) => {           
          var daylog = Object.entries(daylogo)[1][1];
          var qsel = '.day' + daylog.reportday;
          try {
            document.querySelector(qsel).setAttribute('href',"daylogs/" + daylog.id + "/edit");
            document.querySelector(qsel).classList.add('haslink');
            const linkoverlay = document.createElement('span');
            linkoverlay.classList.add('editdayloglinkoverlay');
            document.querySelector(qsel).appendChild(linkoverlay);
          }
          catch(e) {
              /* day didnt exist in dom */
          }
        });
      }
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>